import {
  acknowledgeNotificationDTO,
  acknowledgeNotificationMultiple,
  getNotification,
} from 'wisestep-api';

export const acknowledgeNotificationsMultiple = async () => {
  const notificationResponse = await getNotification({
    page: 0,
    size: 10,
    sort: 'createdOn,desc',
  });
  if (notificationResponse.data) {
    const payload: acknowledgeNotificationDTO[] = [];
    notificationResponse.data.forEach((single: acknowledgeNotificationDTO) => {
      const singleNotification = single;
      singleNotification.keyedData = {};
      singleNotification.data.forEach((_single, index) => {
        singleNotification.keyedData[singleNotification.data[index].key] =
          singleNotification.data[index].value;
      });
      payload.push(singleNotification);
    });
    try {
      await acknowledgeNotificationMultiple(payload);
    } catch (error) {
      //Ignore
    }
  }
};
